<template>
  <NuxtLayout>
    <NodesSection />
  </NuxtLayout>
</template>

<script lang="ts" setup>
import NodesSection from '~/components/Nodes/NodesSection.vue';

useSeoMeta({
  title: 'Nodes',
});
</script>
